import React from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { ArrowRight, Flower2, Moon, Sun, Leaf } from "lucide-react";

const HERO_BG = "#0B1511";
const GOLD = "#E2C089";
const IVORY = "#F5F0E6";
const FEATURES = [[Flower2, "Mindful Design"], [Moon, "Inclusive for All"], [Sun, "Honest & Private"], [Leaf, "Built for Your Growth"]];

export default function About() {
    const { user } = useApp();
    const nav = useNavigate();
    return (
        <div data-testid="about-page">
            <section className="relative overflow-hidden" style={{ background: HERO_BG }}>
                <img src="/art-about-hero.jpg" alt="A glowing head silhouette with chakras beside a moonlit archway over a lake" className="absolute inset-0 w-full h-full object-cover object-right" />
                <div className="absolute inset-0" style={{ background: `linear-gradient(90deg, ${HERO_BG} 0%, ${HERO_BG}E6 22%, ${HERO_BG}66 42%, ${HERO_BG}00 60%)` }} />
                <div className="absolute inset-0 lg:hidden" style={{ background: `linear-gradient(180deg, ${HERO_BG}99 0%, ${HERO_BG}CC 100%)` }} />
                <div className="relative max-w-7xl mx-auto px-6 sm:px-10 lg:px-24 py-20 sm:py-28 lg:py-36 min-h-[520px] lg:min-h-[680px] flex items-center">
                    <div className="max-w-md">
                        <p className="uppercase tracking-[0.4em] text-xs" style={{ color: GOLD }}>About Us</p>
                        <h1 className="mt-6 font-serif text-5xl sm:text-6xl lg:text-7xl leading-[0.98]" style={{ color: IVORY }}>
                            A Safe Space<br /><em className="italic" style={{ color: GOLD }}>to Be You.</em>
                        </h1>
                        <span className="block mt-7 h-px w-14" style={{ background: GOLD }} />
                        <p className="mt-8 text-lg leading-relaxed" style={{ color: `${IVORY}E0` }}>
                            WHY-AM was created to give you a calm, private space to explore your thoughts, feelings and life patterns — without labels, judgement or pressure.
                        </p>
                        <button data-testid="about-start-journey" onClick={() => nav(user ? "/assessment" : "/onboarding")}
                            className="mt-10 inline-flex items-center gap-3 rounded-xl px-8 py-4 text-base font-medium transition hover:brightness-105"
                            style={{ background: "#F0DDB0", color: "#24210F" }}>
                            Start Your Journey <ArrowRight size={18} />
                        </button>
                    </div>
                </div>
            </section>

            <section className="relative overflow-hidden" style={{ background: "#F3EEE2" }}>
                <img src="/art-leaves.jpg" alt="" aria-hidden="true" className="absolute -left-24 -top-16 w-72 opacity-20 rotate-180 pointer-events-none" />
                <img src="/art-leaves.jpg" alt="" aria-hidden="true" className="absolute -right-24 -bottom-24 w-72 opacity-20 pointer-events-none" />
                <div className="relative max-w-7xl mx-auto px-6 sm:px-10 py-14 lg:py-20 grid grid-cols-2 lg:grid-cols-4">
                    {FEATURES.map(([Icon, label], i) => (
                        <div key={label} data-testid={`about-feature-${label}`} className={`flex flex-col items-center text-center gap-5 py-6 ${i > 0 ? "lg:border-l" : ""} ${i % 2 === 1 ? "border-l lg:border-l" : ""}`}
                            style={{ borderColor: "#1F3A3022" }}>
                            <Icon size={56} strokeWidth={1.1} style={{ color: "#A8732F" }} />
                            <span className="font-medium text-lg sm:text-xl lg:text-2xl" style={{ color: "#1F3A30" }}>{label}</span>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
}
